import React from 'react';
import { string, node } from 'prop-types';

import './list-header-title.m.css';

const ListHeaderTitle = ({ children, title, iconCode }) => (
  <h2 styleName="list-header-title" className="list-header-title truncate-overflow">
    {iconCode ? (
      <div styleName="icon-container">
        <i
          className={iconCode}
          style={{
            fontSize: `var(--base-medium)`,
            color: `var(--font4-color)`
          }}
        />
      </div>
    ) : (
      children
    )}
    {title === 'IPOs' ? <span styleName="ipos-style">{title}</span> : title}
  </h2>
);

ListHeaderTitle.propTypes = {
  children: node,
  title: string,
  iconCode: string
};

ListHeaderTitle.defaultProps = {
  children: null,
  title: '',
  iconCode: null
};

export default ListHeaderTitle;
